import { MutableRefObject, useEffect, useState } from 'react';

export const useScrollPosition = (container: MutableRefObject<HTMLDivElement>) => {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    if (!container?.current) return;

    const updatePosition = () => {
      setScrollPosition(container.current.scrollTop);
    };
    container.current.addEventListener('scroll', updatePosition);
    updatePosition();
    return () => window.removeEventListener('scroll', updatePosition);
  }, [container?.current?.offsetHeight]);

  const scrollTo = (position: number) => {
    if (container?.current) {
      container.current.scrollTo({ top: position, behavior: 'smooth' });
    }
  };

  return { scrollPosition, scrollTo };
};
